import { useEffect, useRef, useState } from "react";
import FormControl from "./FormControl"; // 사용중이신 FormControl import

interface SplitDateInputProps {
  value: string; // "YYYY-MM-DD" 형태
  onChange: (newValue: string) => void;
}

export default function SplitDateInput({ value, onChange }: SplitDateInputProps) {
  // 입력된 value("2025-12-25")를 쪼개서 각 변수에 할당
  // 값이 없거나 형식이 안 맞을 경우를 대비해 안전하게 처리
  const [y, m, d] = value.split("-").length === 3 ? value.split("-") : ["", "", ""];

  const yearRef = useRef<HTMLInputElement>(null);
  const monthRef = useRef<HTMLInputElement>(null);
  const dayRef = useRef<HTMLInputElement>(null);

  // 값 변경 핸들러 (part: 'year' | 'month' | 'day')
  const handleChange = (part: string, val: string) => {
    // 숫자만 남기기
    const num = val.replace(/\D/g, "");

    let newY = y;
    let newM = m;
    let newD = d;

    if (part === "year") {
      if (num.length > 4) return;
      newY = num;
      // 4자리 차면 월(Month)로 포커스
      if (num.length === 4) monthRef.current?.focus();
    } else if (part === "month") {
      if (num.length > 2) return;
      newM = num;
      // 2자리 차면 일(Day)로 포커스
      if (num.length === 2) dayRef.current?.focus();
    } else if (part === "day") {
      if (num.length > 2) return;
      newD = num;
    }

    // 부모에게 합쳐진 문자열 전달 (YYYY-MM-DD)
    onChange(`${newY}-${newM}-${newD}`);
  };

  return (
    <div className="d-flex align-items-center gap-1">
      {/* 년도 */}
      <div style={{ width: "60px" }}>
        <FormControl
          ref={yearRef}
          small
          value={y}
          placeholder="YYYY"
          onChange={(e) => handleChange("year", e.target.value)}
          style={{ textAlign: "center" }} // 가운데 정렬하면 예쁨
        />
      </div>
      <span className="bg-transparent">-</span>
      
      {/* 월 */}
      <div style={{ width: "45px" }}>
        <FormControl
          ref={monthRef}
          small
          value={m}
          placeholder="MM"
          onChange={(e) => handleChange("month", e.target.value)}
          style={{ textAlign: "center" }}
        />
      </div>
      <span className="bg-transparent">-</span>

      {/* 일 */}
      <div style={{ width: "45px" }}>
        <FormControl
          ref={dayRef}
          small
          value={d}
          placeholder="DD"
          onChange={(e) => handleChange("day", e.target.value)}
          style={{ textAlign: "center" }}
        />
      </div>
    </div>
  );
}